import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { Dialog, Tooltip } from "@material-ui/core";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";

import {
  getPOPbankNames,
  hideLoader,
  redirectToDigilocker,
  showLoader,
} from "../../../../store/actions";
import CardComponent from "../../transactions/newInvestor/lib/CardComponent";
import { useNewSubscriberContext } from "../Context/NewSubsciberContext";
import { setPOPbankDetails, setSkipKyc } from "../Context/NewSubscriberAction";
import AadhaarContainer from "./lib/AadhaarContainer";
import CustomInputField from "./lib/InputField";
import Kyc from "./PanKyc";
import { SUCCESS_RESPONSE_CODE } from ".";

const KycDetails = (props) => {
  const {
    kycDetails,
    aadhaarDetails,
    dispatch: dispatchContext,
    ResidenceType,
  } = useNewSubscriberContext();

  const contextData = useNewSubscriberContext();
  const dispatch = useDispatch();
  const history = useHistory();

  const [kycType, setkycType] = useState(!!aadhaarDetails ? "150" : "");
  const [skipDialogDisplay, setSkipDialogDisplay] = useState(false);

  const optedKycType = kycDetails?.data?.IdentifierType;

  const gotoDigiLocker = async () => {
    localStorage.setItem("newSub", JSON.stringify(contextData));
    await dispatch(redirectToDigilocker());
  };

  const changeKycType = (e) => {
    const value = e.target.value;
    if (Number(value) === 150) {
      gotoDigiLocker();
      return;
    }
    setkycType(value);
  };

  useEffect(() => {
    if (Boolean(optedKycType) && optedKycType !== "0") {
      alert("KYC Details has already been submitted successfully");
      history.push("/nps/AddSubs/personal-details");
      return;
    }

    const fetchKycOptions = async () => {
      try {
        dispatch(showLoader());
        const responseBank = await dispatch(getPOPbankNames());
        if (+responseBank.statusCode === SUCCESS_RESPONSE_CODE) {
          dispatchContext(setPOPbankDetails(responseBank));
        }
      } catch (error) {
        alert(error);
        console.error(error);
      } finally {
        dispatch(hideLoader());
      }
    };
    fetchKycOptions();
    if (Number(ResidenceType) !== 1) {
      setkycType("");
      // setkycType("119");
    }
  }, [dispatch, ResidenceType, dispatchContext]);

  const Proceed = () => {
    dispatchContext(setSkipKyc(!!skipDialogDisplay));
    history.push("/nps/AddSubs/personal-details");
  };

  const Skip = () =>
    Number(kycType) !== 150 ? (
      <div>
        {/* <Tooltip
          title={
            <h6>
              Skip KYC button signifies that instead of the distributor, the
              subscriber will complete the KYC after onboarding.
            </h6>
          }
        > */}
        <button className="skip" onClick={() => setSkipDialogDisplay(true)}>
          Skip
        </button>
        {/* </Tooltip> */}
      </div>
    ) : null;

  return (
    <>
      {
        <Dialog open={skipDialogDisplay}>
          <div className="skip-dialog">
            <div className="popup-header">
              KYC details will be requested by the investor.
            </div>
            <div className="d-flex justify-content-center">
              <button
                className="new-investor-button"
                style={{ border: "1px solid #007ac8", color: "#007ac8" }}
                onClick={() => setSkipDialogDisplay(false)}
              >
                Cancel
              </button>
              <button
                className="new-investor-button new-investor-active"
                onClick={Proceed}
              >
                Proceed
              </button>
            </div>
          </div>
        </Dialog>
      }
      <div className="container-margin">
        <CardComponent title="KYC DETAILS">
          {Number(ResidenceType) === 1 && Number(kycType) !== 150 ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "15px",
                gap: "10px",
                padding: "24px",
              }}
            >
              <ReportProblemOutlinedIcon
                style={{ color: "goldenrod", fontSize: "20px" }}
              />
              We couldn't fetch the existing KYC details from CKYC. Please
              proceed with the following options to continue further
            </div>
          ) : null}
          <Skip />
          {Number(kycType) !== 150 ? (
            <div style={{ padding: "0px 12px" }}>
              {Number(ResidenceType) === 1 ? (
                <CustomInputField
                  type={"radio"}
                  options={[
                    {
                      label: "Aadhaar linked with mobile number",
                      value: "150",
                    },
                    {
                      label: "Bank Account Verification",
                      value: "119",
                      disabled: true,
                    },
                  ]}
                  label={"Register for KYC With"}
                  value={kycType}
                  onChange={changeKycType}
                  required
                />
              ) : (
                <CustomInputField
                  type={"radio"}
                  options={[
                    {
                      label: "Bank Account Verification",

                      value: "119",
                      disabled: true,
                    },
                  ]}
                  label={"Register for KYC With"}
                  value={kycType}
                  onChange={changeKycType}
                  required
                />
              )}
            </div>
          ) : null}
          {!!aadhaarDetails ? (
            // <CardComponent title="e-Aadhaar">
            <AadhaarContainer />
          ) : (
            // </CardComponent>
            <>{+kycType === 119 && <Kyc />}</>
          )}
        </CardComponent>
      </div>
    </>
  );
};

export default KycDetails;
